module.exports = "/assets/0cefcd8ed5450532b4f9e6b440250ca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/AM.png
// module id = 1200
// module chunks = 0